import {
    Filter,
    Plus,
    Folder,
    FolderPlus,
    Image,
    ImagePlus,
    ClipboardPlus,
    ClipboardList,
    ArrowLeft,
    FileDown,
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export default function FoldersActionBar({
    depth,
    onFilter,
    onCreate,
    onAddPhoto,
    onAddProcedure,
    onBack,
    activeFilterCount = 0,
    mandatoryProceduresCount,
    onMandatoryProcedures,
    onExportReports,
}) {
    const { t } = useTranslation();
    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
                <Button
                    variant="outline"
                    color="neutral"
                    className="gap-[6px] p-0 md:px-[16px] md:py-[10px] bg-card rounded-[8px] hover:bg-muted/50 border-border w-[40px] h-[40px] md:w-auto md:h-auto"
                    onClick={onFilter}
                >
                    <Filter className="w-4 h-4 text-muted-foreground" />
                    <span className="hidden md:inline text-[14px] text-foreground">{t('folders:filtrer')}</span>
                    {activeFilterCount > 0 && (
                        <span className="flex items-center justify-center min-w-[20px] h-[20px] px-[6px] bg-primary rounded-[4px] text-[11px] text-primary-foreground font-medium">
                            {activeFilterCount}
                        </span>
                    )}
                </Button>

                {depth === 0 && onExportReports && (
                    <Button
                        variant="outline"
                        color="neutral"
                        className="gap-[6px] p-0 md:px-[16px] md:py-[10px] bg-card rounded-[8px] hover:bg-muted/50 border-border w-[40px] h-[40px] md:w-auto md:h-auto"
                        onClick={onExportReports}
                    >
                        <FileDown className="w-4 h-4 text-muted-foreground" />
                        <span className="hidden md:inline text-[14px] text-foreground">{t('folders:exporterLesRapports')}</span>
                    </Button>
                )}
            </div>

            {depth !== undefined && (
                <div className="flex items-center gap-3">
                    {onMandatoryProcedures && mandatoryProceduresCount && (
                        <Button variant="outline" color="warning" className="gap-[6px]" onClick={onMandatoryProcedures}>
                            <ClipboardList className="w-4 h-4" />
                            <span className="text-[13px]">
                                {t('folders:proceduresObligatoires')}{' '}
                                <span className="font-semibold">{mandatoryProceduresCount}</span>
                            </span>
                        </Button>
                    )}
                    {depth === 0 ? (
                        // Root level: only create folder
                        onCreate && (
                            <Button variant="solid" color="primary" onClick={onCreate}>
                                <Plus className="w-4 h-4" />
                                <span className="hidden md:inline">{t('folders:ajouter')}</span>
                            </Button>
                        )
                    ) : (
                        // Inside a folder: all actions
                        <>
                            {depth >= 1 && (
                                <>
                                    {/* Add sub-folder button */}
                                    {onCreate && (
                                        <Button variant="solid" color="primary" onClick={onCreate}>
                                            <FolderPlus className="w-4 h-4" />
                                            <span className="hidden md:inline">{t('folders:ajouter')}</span>
                                        </Button>
                                    )}

                                    {/* Add procedure button */}
                                    {onAddProcedure && (
                                        <Button variant="solid" color="primary" onClick={onAddProcedure}>
                                            <ClipboardPlus className="w-4 h-4" />
                                            <span className="hidden md:inline">{t('folders:ajouter')}</span>
                                        </Button>
                                    )}
                                </>
                            )}

                            {/* Add photo button */}
                            {onAddPhoto && (
                                <Button variant="solid" color="secondary" onClick={onAddPhoto}>
                                    <ImagePlus className="w-4 h-4" />
                                    <span className="hidden md:inline">{t('folders:ajouter')}</span>
                                </Button>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
